/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type GoalType = "completable" | "continuous" | "%future added value";
export type GoalDetailsSettingsDueDate_goal = {
    readonly type: GoalType;
    readonly " $fragmentRefs": FragmentRefs<"GoalDetailsSettingsDueDateSelect_goal">;
    readonly " $refType": "GoalDetailsSettingsDueDate_goal";
};
export type GoalDetailsSettingsDueDate_goal$data = GoalDetailsSettingsDueDate_goal;
export type GoalDetailsSettingsDueDate_goal$key = {
    readonly " $data"?: GoalDetailsSettingsDueDate_goal$data;
    readonly " $fragmentRefs": FragmentRefs<"GoalDetailsSettingsDueDate_goal">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GoalDetailsSettingsDueDate_goal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GoalDetailsSettingsDueDateSelect_goal"
    }
  ],
  "type": "Goal",
  "abstractKey": null
};
(node as any).hash = 'b5f97394224cbc75ef5a9dde8b3721e5';
export default node;
